import type { TrailDefinition, TrailContext } from './types'

interface RainbowParticle {
  x: number
  y: number
  vx: number
  vy: number
  life: number
  maxLife: number
  size: number
  hue: number
}

const MAX_PARTICLES = 70

export const rainbow: TrailDefinition = {
  id: 'rainbow',
  name: 'Rainbow',

  init() {
    return { particles: [] as RainbowParticle[], hueOffset: 0 }
  },

  update(state: unknown, ctx: TrailContext) {
    const s = state as { particles: RainbowParticle[], hueOffset: number }
    const dt = ctx.deltaTime / 1000
    s.hueOffset += dt * 120 // cycle hue over time

    if (ctx.mouseActive && dt > 0) {
      const spawnCount = Math.min(3, MAX_PARTICLES - s.particles.length)
      for (let i = 0; i < spawnCount; i++) {
        const angle = Math.random() * Math.PI * 2
        const speed = 20 + Math.random() * 50
        s.particles.push({
          x: ctx.mouseX + (Math.random() - 0.5) * 6,
          y: ctx.mouseY + (Math.random() - 0.5) * 6,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          life: 1,
          maxLife: 0.4 + Math.random() * 0.4,
          size: 2 + Math.random() * 3,
          hue: (s.hueOffset + Math.random() * 60) % 360
        })
      }
    }

    for (let i = s.particles.length - 1; i >= 0; i--) {
      const p = s.particles[i]
      p.life -= dt / p.maxLife
      p.x += p.vx * dt
      p.y += p.vy * dt
      p.vx *= 0.97
      p.vy *= 0.97
      p.vy += 10 * dt

      if (p.life <= 0) {
        s.particles.splice(i, 1)
      }
    }
  },

  draw(state: unknown, ctx: TrailContext) {
    const s = state as { particles: RainbowParticle[] }
    const c = ctx.ctx

    for (const p of s.particles) {
      const alpha = Math.max(0, p.life)
      const size = p.size * (0.4 + alpha * 0.6)

      c.beginPath()
      c.arc(p.x, p.y, size, 0, Math.PI * 2)
      c.fillStyle = `hsla(${p.hue}, 90%, 65%, ${alpha})`
      c.fill()

      // Subtle glow
      const glowSize = size * 3
      const gradient = c.createRadialGradient(p.x, p.y, 0, p.x, p.y, glowSize)
      gradient.addColorStop(0, `hsla(${p.hue}, 90%, 65%, ${alpha * 0.2})`)
      gradient.addColorStop(1, 'transparent')
      c.fillStyle = gradient
      c.fillRect(p.x - glowSize, p.y - glowSize, glowSize * 2, glowSize * 2)
    }
  }
}
